import BaseService from './base.service';

export default class VehicleService {
    static ENDPOINT = '/vehicles';

    static async getSupportedCountries() {
        const endpoint = `${this.ENDPOINT}/countries`;
        return BaseService.get(endpoint);
    }

    static async getCountryByCode(code) {
        const endpoint = `${this.ENDPOINT}/countries/${code}`;
        return BaseService.get(endpoint);
    }

    static async getVehicleMakes() {
        const endpoint = `${this.ENDPOINT}/makes`;
        return BaseService.get(endpoint);
    }

    static async getVehicleColors() {
        const endpoint = `${this.ENDPOINT}/colors`;
        return BaseService.get(endpoint);
    }

    static async checkVehiclePlate(checkVehiclePlate) {
        const endpoint = `${this.ENDPOINT}/check`;
        return BaseService.post(endpoint, checkVehiclePlate);
    }

    static async searchVehicle(searchVehicleData) {
        const endpoint = `${this.ENDPOINT}/search`;
        return BaseService.post(endpoint, searchVehicleData);
    }

    static async createVehicle(createVehicleData) {
        const endpoint = `${this.ENDPOINT}`;
        return BaseService.post(endpoint, createVehicleData);
    }

    static async getMyVehicles() {
        const endpoint = `${this.ENDPOINT}/me`;
        return BaseService.get(endpoint);
    }

    static async getVehicle(vehicleId) {
        const endpoint = `${this.ENDPOINT}/${vehicleId}`;
        return BaseService.get(endpoint);
    }

    static async updateVehicle(vehicleId, updateVehicleData) {
        const endpoint = `${this.ENDPOINT}/${vehicleId}`;
        return BaseService.patch(endpoint, updateVehicleData);
    }

    static async deleteVehicle(vehicleId) {
        const endpoint = `${this.ENDPOINT}/${vehicleId}`;
        return BaseService.delete(endpoint);
    }

    static async connectVehicleToProperty(vehicleId, connectPropertyData) {
        const endpoint = `${this.ENDPOINT}/${vehicleId}/connect-property`;
        return BaseService.post(endpoint, connectPropertyData);
    }

    static async revokeOwnLicense(vehicleId, licenseId) {
        const endpoint = `${this.ENDPOINT}/${vehicleId}/lpr-licenses/${licenseId}/revoke`;
        return BaseService.post(endpoint);
    }

    static async getVehicleLicenses(vehicleId) {
        const endpoint = `${this.ENDPOINT}/${vehicleId}/lpr-licenses`;
        return BaseService.get(endpoint);
    }
}
